<script>
import baseList from "@/views/components/base/baseList.vue";
import { Tag, Button } from "view-design";
import Vue from "vue";
import Info from "../info.vue";

export default {
  extends: baseList,
  components: {
    info: Info,
  },
  data() {
    return {
      table: {
        mname: "recycle",
        key: "id",
        url: {
          list: "/admin/system/work/recycle",
        },
        output: false,
      },
      menus: [
        {
          label: "待处理",
          name: "workOrder_list",
          auth: "system/workOrder/index",
          badge: { mname: "workstate", scene: "1", url: "/admin/system/work/state" },
        },
        {
          label: "处理中",
          name: "processing_list",
          auth: "system/processing/index",
          badge: { mname: "workstate", scene: "2", url: "/admin/system/work/state" },
        },
        {
          label: "挂起中",
          name: "workPending_list",
        },
        {
          label: "已完成",
          name: "completed_list",
          auth: "system/completed/index",
          // badge: { mname: "workstate", scene: "3" },
        },
        {
          label: "抢单池",
          name: "workOrder_seize",
          badge: { mname: "workstate", scene: "4", url: "/admin/system/work/state" },
        },
        {
          label: "回收站",
          name: "workOrder_recyle",
        },
      ],
      query: {},
      actions: [],
      filters: [
        {
          label: "报修时间",
          KeyEnter: this.search,
          name: "",
          value: "",
          type: "datetimerange",
        },
        {
          label: "工单类型",
          name: "typeId",
          value: "",
          KeyEnter: this.search,
          type: "select",
          dropList: [],
        },
        {
          label: "报修人电话",
          name: "repairPhone",
          value: "",
          KeyEnter: this.search,
          type: "input",
        },
        {
          label: "报修人",
          KeyEnter: this.search,
          name: "repairBy",
          value: "",
          type: "input",
        },
        // {
        //   label: "资产",
        //   name: "facilityNo",
        //   value: "",
        //   KeyEnter: this.search,
        //   type: "select",
        //   dropList: [],
        // },
        {
          label: "资产名称",
          name: "facilityName",
          value: "",
          KeyEnter: this.search,
          type: "input",
        },
        {
          label: "问题描述",
          KeyEnter: this.search,
          name: "descr",
          value: "",
          type: "input",
        },
        {
          label: "处理人",
          KeyEnter: this.search,
          name: "maintainerName",
          value: "",
          type: "input",
        },
        {
          label: "科室",
          name: "department",
          value: "",
          KeyEnter: this.search,
          type: "input",
        },
        {
          label: "资产编号",
          KeyEnter: this.search,
          name: "assetNum",
          value: "",
          type: "input",
        },
        {
          label: "工单状态",
          KeyEnter: this.search,
          name: "state",
          value: "",
          type: "select",
          dropList: [
            {
              value: 1,
              name: "待处理",
            },
            {
              value: 2,
              name: "处理中",
            },
            {
              value: 3,
              name: "已完成",
            },
          ],
        },
        {
          label: "报修方式",
          name: "repairType",
          value: "",
          KeyEnter: this.search,
          type: "select",
          dropList: [
            {
              value: 1,
              name: "电话报修",
            },
            {
              value: 2,
              name: "扫码报修",
            },
            {
              value: 3,
              name: "移动报修",
            },
            {
              value: 4,
              name: "后台设备报修",
            },
            {
              value: 5,
              name: "后台科室报修",
            },
            {
              value: 6,
              name: "维修员",
            },
            {
              value: 7,
              name: "用户PC普通",
            },
            {
              value: 8,
              name: "用户PC快速",
            },
          ],
        },
      ],
      tableCols: [
        {
          title: "序号",
          type: "index",
          width: 80,
          align: "center",
        },
        {
          title: "报修时间",
          width: 180,
          align: "center",
          key: "repairTime",
          sortable: true,
          render: (h, params) => {
            const row = params.row;
            const text = row.createTime.slice(0, 16);
            return <span>{text}</span>;
          },
        },
        {
          title: "问题描述",
          key: "descr",
          width: 280,
          align: "left",
          tooltip: "true",
        },
        /*   {
            title: "工单类型",
            key: "typeName",
            minWidth: 120,
            align: "left",
            tooltip: "true",
          }, */
        {
          title: "所在科室",
          key: "department",
          minWidth: 120,
          align: "left",
          tooltip: "true",
        },
        {
          title: "报修人",
          width: 120,
          align: "center",
          key: "repairBy",
          // sortable: true,
          tooltip: "true",
        },
        /* {
          title: "具体位置",
          key: "address",
          minWidth: 120,
          align: "left",
          tooltip: "true",
        },
        {
          title: "报修人",
          minWidth: 100,
          align: "left",
          key: "repairBy",
          sortable: true,
          tooltip: "true",
        },
        {
          title: "报修电话",
          key: "repairPhone",
          minWidth: 130,
          align: "left",
          copy: true,
        },

        {
          title: "协同工单",
          key: "isSynergy",
          minWidth: 100,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text = row.isSynergy === 0 ? "否" : "是";
            return <span style={{ "font-size": "14px" }}>{text}</span>;
          },
        },

        {
          title: "状态",
          key: "state",
          minWidth: 100,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text = row.state === 1 ? "待处理" :row.state === 2 ? "处理中" :row.state === 3 ? "已完成" : "";
            return <span style={{ "font-size": "14px" }}>{text}</span>;
          },
        },
        {
          title: "报修来源",
          key: "repairSource",
          width: 140,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text =
              row.repairSource === 1 && row.isFastOrder === 0
                ? "扫码报修"
                : row.repairSource === 1 && row.isFastOrder === 1
                ? "移动报修"
                : row.repairSource === 4
                ? row.repairPhone
                  ? row.repairPhone
                  : "电话报修"
                : row.repairSource === 5 && row.isFastOrder === 0
                ? "用户PC普通"
                : row.repairSource === 5 && row.isFastOrder === 1
                ? "用户PC快速"
                : row.repairSource === 3 && row.isFastOrder === 0
                ? "后台设备报修"
                : row.repairSource === 3 && row.isFastOrder === 1
                ? "后台科室报修"
                : row.repairSource === 2
                ? "维修员"
                : "";
            return <span style={{ "font-size": "14px" }}>{text}</span>;
          },
        }, */
        {
          title: "处理人",
          key: "maintainerName",
          width: 120,
          align: "center",
        },
        {
          title: "操作",
          align: "center",
          width: 150,
          key: "handle",
          fixed: "right",
          handle: [
            (vm, h, currentRow, param) => {
              // let directives = [];
              let directives = [{ name: "auth", value: "system/workOrder/info" }];
              return (
                <Button
                  {...{ directives }}
                  size="small"
                  onClick={() => this.toInfo(currentRow)}
                  type="default"
                  style={{
                    border: "none",
                    color: "#4991ff",
                    marginLeft: "5px",
                  }}
                >
                  详情
                </Button>
              );
            },
            (vm, h, currentRow, param) => {
              let directives = [];
              return (
                <Button
                  {...{ directives }}
                  size="small"
                  onClick={() => this.toResume(currentRow)}
                  type="default"
                  style={{
                    border: "none",
                    color: "#4991ff",
                    marginLeft: "5px",
                  }}
                >
                  恢复
                </Button>
              );
            },
          ],
        },
      ],
    };
  },
  created() {
    // this.loadLevelData();
    this.loadLevelDatas();
    this.loaddeskData();
  },
  methods: {
    deskChange(query) {
      if (query !== "") {
        setTimeout(async () => {
          let q = {
            deskName: query,
          };

          $utils.api.load(`/admin/system/desk/selectList`, q, "get").then((res) => {
            const list = res.rows.map((item) => {
              return {
                value: item.id,
                name: item.deskName,
              };
            });
            for (let index = 0; index < this.filters.length; index++) {
              const element = this.filters[index];
              if (element && element.name == "deskId") {
                this.filters[index]["dropList"] = list;
              }
            }
          });
        }, 200);
      } else {
        this.dropList = [];
      }
    },
    loaddeskData() {
      // 通过pk查询字典数据
      let q = {};
      // q.state=1
      $utils.api.load(`/admin/system/desk/selectList/?isParent=${"0"}`, q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.id;
            xx.name = element.deskName;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          for (let index = 0; index < this.filters.length; index++) {
            const element = this.filters[index];
            if (element && element.name == "deskId") {
              this.filters[index]["dropList"] = dropList;
            }
          }
        }
      });
    },
    loadLevelDatas() {
      // 通过pk查询字典数据
      let q = {};
      // q.state=1
      $utils.api.load("/admin/system/workType/selectList", q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.id;
            xx.name = element.name;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          for (let index = 0; index < this.filters.length; index++) {
            const element = this.filters[index];
            if (element && element.name == "typeId") {
              this.filters[index]["dropList"] = (element["dropList"] || []).concat(
                dropList
              );
            }
          }
        }
      });
    },
    loadLevelData() {
      // 通过pk查询字典数据
      let q = {};
      // q.state=1
      $utils.api.load("/admin/system/facility/selectList", q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.facilityNum;
            xx.name = element.facilityName;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          for (let index = 0; index < this.filters.length; index++) {
            const element = this.filters[index];
            if (element && element.name == "facilityNo") {
              this.filters[index]["dropList"] = (element["dropList"] || []).concat(
                dropList
              );
            }
          }
        }
      });
    },

    //详情
    toInfo(row) {
      $utils.url.push({
        name: "workOrder_info",
        query: { action: "edit", kv: row.id, workId: row.id },
      });
    },

    async toResume(row) {
      let res = await $utils.api.load(`/admin/system/work/resume/${row.id}`, {}, "post");
      if (res && res.code === 200) {
        $utils.toast.text(res.msg);
        this.search();
      }
    },
  },
};
</script>
<style scoped></style>
